export default "__VITE_ASSET__6963c3db__"